module.exports = __webpack_public_path__ + "static/media/golfPlayer.af414233.png";